import React, { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Navbar from '../Components/Navbar/navbar';
import './NovoCadastroMateriais.css';

// FIREBASE MODULAR
import { db } from "../Config/firebase";
import { 
  collection,
  doc,
  runTransaction,
  Timestamp
} from "firebase/firestore";
import { aplicarTenantAtual } from "../Utils/tenant";


function NovoCadastroMateriais() {

  const [codigo, setCodigo] = useState('');
  const [datacadastro, setDataCadastro] = useState('');
  const [cliente, setCliente] = useState('');
  const [fornecedor, setFornecedor] = useState('');
  const [descricao, setDescricao] = useState('');
  const [ensaios, setEnsaios] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [sucesso, setSucesso] = useState('N');

  const [loading, setLoading] = useState(false); // ⬅️ estado de loading

  async function CadastrarMaterial() {

  setMensagem('');

  if (!datacadastro) {
    setMensagem("Informe a data de registro.");
    return;
  }

  if (!cliente.trim()) {
    setMensagem("Informe o cliente.");
    return;
  }

  if (!descricao.trim()) {
    setMensagem("Informe a descrição.");
    return;
  }

  try {

    setLoading(true);

    const contadorRef = doc(db, "contadores", "materiais");
    const listaRef = collection(db, "tblListaMateriaisCadastrados");

    await runTransaction(db, async (transaction) => {

        const contadorDoc = await transaction.get(contadorRef);

        let novoCodigo = 1;

        if (!contadorDoc.exists()) {

          // primeira vez que o sistema roda
          novoCodigo = 1;

          transaction.set(contadorRef, {
            ultimoCodigo: 1
          });

        } else {

          novoCodigo = contadorDoc.data().ultimoCodigo + 1;

          transaction.update(contadorRef, {
            ultimoCodigo: novoCodigo
          });

        }

        const novoMaterialRef = doc(listaRef);

        transaction.set(novoMaterialRef, aplicarTenantAtual({

          codigo: novoCodigo,

          DataCadastro: datacadastro
            ? (() => {
                const [ano, mes, dia] = datacadastro.split("-");
                return Timestamp.fromDate(new Date(ano, mes - 1, dia));
              })()
            : null,

          Cliente: cliente,
          Fornecedor: fornecedor,
          Descricao: descricao,
          Ensaios: ensaios

        }));

      });

    setSucesso('S');

  } catch (erro) {

    console.error(erro);
    setMensagem("Erro ao cadastrar: " + erro.message);
    setSucesso('N');

  } finally {

    setLoading(false);

  }
}

  return (
    <div>
      <Navbar />

      <div className="container-fluid titulo">
        <div className="offset-lg-3 col-lg-6">

          <h1>Novo Material</h1>

          <form autoComplete="off" noValidate onSubmit={(e) => e.preventDefault()}>

            <div className="mb-3">
                    <label className="form-label">Código</label>
                    <input 
                      type="text"
                      value="Automático"
                      readOnly
                      className="form-control"
                    />
                  </div>

            <div className="mb-3">
              <label className="form-label">Data Registro</label>
              <input 
              required
                onChange={(e) => setDataCadastro(e.target.value)} 
                type="date"
                className="form-control"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Cliente</label>
              <input 
              required
                onChange={(e) => setCliente(e.target.value)} 
                type="text"
                className="form-control"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Fornecedor</label>
              <input 
                onChange={(e) => setFornecedor(e.target.value)} 
                type="text"
                className="form-control"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Descrição</label>
              <input 
              required
                onChange={(e) => setDescricao(e.target.value)} 
                type="text"
                className="form-control"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Ensaios a serem realizados</label>
              <input 
                onChange={(e) => setEnsaios(e.target.value)} 
                type="text"
                className="form-control"
              />
            </div>

            {/* BOTÕES */}
            <div className="text-center mt-3">
              <Link to="/app/home" className="btn btn-outline-primary btn-acao me-3">
                Cancelar
              </Link>

              <button 
                onClick={CadastrarMaterial} 
                type="button" 
                className="btn btn-primary btn-acao"
                disabled={loading} // ⬅️ desabilita botão enquanto salva
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Salvando...
                  </>
                ) : (
                  "Salvar"
                )}
              </button>
            </div>

            {mensagem && <div className="alert alert-danger mt-3">{mensagem}</div>}
            {sucesso === 'S' && <Redirect to="/app/home" />}

          </form>
        </div>
      </div>
    </div>
  );
}

export default NovoCadastroMateriais;
